"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import AddBookingForm from "./addBookingForm";

type Me = {
  type: "GUEST";
  id: number;
  company_id: number;
  email: string;
};

type GuestGateProps = {
  roomId: number;
  companySlug: string;
};

export default function GuestGate({
  roomId,
  companySlug,
}: GuestGateProps) {
  const [me, setMe] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function run() {
      try {
        const apiUrl = process.env.NEXT_PUBLIC_API_URL!;

        const res = await fetch(`${apiUrl}/auth/guest/me`, {
          credentials: "include",
        });

        if (!res.ok) {
          setMe(null);
          return;
        }

        const data = (await res.json()) as Me;
        setMe(data);
      } finally {
        setLoading(false);
      }
    }

    run();
  }, []);

  if (loading) {
    return <p>Checking login…</p>;
  }

  if (!me) {
    return (
      <p>
        Je moet ingelogd zijn als guest om te reserveren.{" "}
        <Link href={`/c/${companySlug}/guest/login`}>
          Guest login
        </Link>
      </p>
    );
  }

  async function logout() {
    const apiUrl = process.env.NEXT_PUBLIC_API_URL!;

    await fetch(`${apiUrl}/auth/guest/logout`, {
      method: "POST",
      credentials: "include",
    });

    setMe(null);
  }

  return (
    <>
      <p style={{ opacity: 0.8 }}>
        Ingelogd als {me.email}
      </p>

      <button onClick={logout}>
        Uitloggen
      </button>

      <hr style={{ margin: "24px 0" }} />

      <AddBookingForm roomId={roomId} />
    </>
  );
}